import FavoriteStudy from "./favorite.studies";
import Paper from "./paper";
import React from "react";
import Search from "./search";
import { Title } from "../app/components";
import styled from "styled-components";
import IconButton from "@material-ui/core/IconButton";
import InfoIcon from "@material-ui/icons/Info";
import Tooltip from "@material-ui/core/Tooltip";
import { withStyles } from "@material-ui/core/styles";

const CustomTooltip = withStyles({
  tooltip: {
    fontSize: "15px",
    borderRadius: "4px",
    backgroundColor: "var(--surface-600)",
    maxWidth: "600px",
  },
})(Tooltip);

const ColoredInfoIcon = styled(InfoIcon)`
  color: var(--teal-600);
`;

const StudyPlanSearch = () => {
  return (
    <Container>
      <nav>
        <Paper>
          <PaperContent>
            <TitleContainer>
              <Title
                color="var(--text-primary)"
                size="small"
              >
                Select a Study or Opportunity
              </Title>
              <CustomTooltip
                arrow
                title="You can search by PCN, Sponsor Name, or Indication"
              >
                <IconButton style={{ marginBottom: "5px" }}>
                  <ColoredInfoIcon fontSize="small" />
                </IconButton>
              </CustomTooltip>
            </TitleContainer>
            <SearchWrapper>
              <Search />
            </SearchWrapper>
            <FavoriteContainer>
              <FavoriteStudy/>
            </FavoriteContainer>
          </PaperContent>
        </Paper>
      </nav>
    </Container>
  );
};

export default StudyPlanSearch;

const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: ${({ hasMargin }) => (hasMargin ? "5%" : "0")};
  position: relative;
`;

const PaperContent = styled.div`
  z-index: 1;
  min-height: 100vh;
  min-height: calc(100vh - 145px);
  display: flex;
  flex-direction: column;
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  overflow: auto;
`;
const SearchWrapper = styled.div`
  margin-bottom: 20px;
`;

const FavoriteContainer = styled.div`
  --base-offset: 250px;
  --min-height: 300px;
  
  height: calc(100vh - var(--base-offset));
  min-height: var(--min-height);
  overflow: hidden;

  /* Responsive adjustments */
  @media (max-height: 600px) {
    --base-offset: 120px;
    --min-height: 200px;
  }

  @media (min-height: 601px) and (max-height: 900px) {
    --base-offset: 170px;
    --min-height: 350px;
  }

  @media (min-height: 901px) and (max-height: 1200px) {
    --base-offset: 250px;
    --min-height: 400px;
  }

  @media (min-height: 1201px) {
    --base-offset: 320px;
    --min-height: 500px;
    max-height: 800px;
  }
`;
